/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

interface IHrefCustomLink {
    text?: string;
    href?: string;
    ariaLabel?: string;
}

export const HrefCustomLink: React.FC<IHrefCustomLink> = ({ text, href, ariaLabel }) => {
    const linkText = text !== undefined ? text : '';
    return (
        <a href={href} aria-label={ariaLabel}>
            <span itemProp='name'>{linkText}</span>
            <meta itemProp='position' content='1' />
        </a>
    );
};
